import styled from 'styled-components';

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 3px;

  &.ListItemOdd {
    background-color: #3F4147;
  }
`;
